import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useParams } from 'react-router';
import { ApiClientService, AuthContext, useApiClient } from 'libs.react_internal';
const fetchEnvironments = async (get, entityId, studyId, withCortexAccess) => {
    const queryParams = new URLSearchParams({ withWorkflows: 'true', clusterTypes: 'dev,ephemeral,sandbox' });
    if (withCortexAccess === true) {
        queryParams.set('withCortexAccess', 'true');
    }
    const url = `/v1/entities/${entityId}/studies/${studyId}/environments?${queryParams}`;
    const response = await get(url);
    return response?.data?.data || [];
};
export const useEnvironments = ({ withCortexAccess = false } = {}) => {
    const { entityId, user } = useContext(AuthContext);
    const { studyId } = useParams();
    const { get } = useApiClient(ApiClientService.MOM);
    const queryKey = ['entities', entityId, 'environments'];
    const queryFn = () => fetchEnvironments(get, entityId, studyId, withCortexAccess);
    const enabled = !!user && !!entityId && !!studyId;
    return useQuery({ queryKey, queryFn, enabled });
};
